import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  NumberField,
  EditButton,
  CardActions,
  ExportButton,
  CreateButton,
  Filter,
  TextInput,
} from 'react-admin';

import { getAdminLevel, ADMIN_LEVELS } from '../../authProvider';
import FetchFolioPrivateQuotesButton from './fetchFolioPrivateQuotesButton';

const currencyFormat = {
  style: 'currency',
  currency: 'USD',
};

const PrivateQuoteListActions = ({
  basePath,
  data,
}) => {
  const adminLevel = getAdminLevel();

  return (
    <CardActions>
      { adminLevel && adminLevel !== ADMIN_LEVELS.READ_ONLY_ADMIN ?
        <CreateButton basePath={basePath} record={data} /> : undefined
      }
      <ExportButton resource="privateQuotes" />
      <FetchFolioPrivateQuotesButton resource="privateQuotes" />
    </CardActions>
  );
};

const CanEdit = ({ basePath, record }) => {
  const adminLevel = getAdminLevel();

  if (adminLevel && adminLevel !== ADMIN_LEVELS.READ_ONLY_ADMIN) {
    return <EditButton basePath={basePath} record={record} />;
  }

  return null;
};

const PrivateQuoteFilter = props => (
  <Filter {...props}>
    <TextInput label="Ticker or Company Name" source="_OMNI_" alwaysOn />
  </Filter>
);


export default props => (
  <List
    {...props}
    title="Private Quotes"
    bulkActionButtons={false}
    sort={{ field: 'id', order: 'asc' }}
    actions={<PrivateQuoteListActions />}
    filters={<PrivateQuoteFilter />}
  >
    <Datagrid>
      <TextField source="ticker" />
      <TextField source="name" />
      <NumberField source="purchasePrice" options={currencyFormat} />
      <NumberField source="currentPrice" options={currencyFormat} />
      <CanEdit {...props} />
    </Datagrid>
  </List>
);



// WEBPACK FOOTER //
// ./src/components/PrivateQuote/List.js